import { render, staticRenderFns } from "./EdiGenericTemplate.vue?vue&type=template&id=27e206d6&lang=pug"
import script from "./EdiGenericTemplate.vue?vue&type=script&lang=js"
export * from "./EdiGenericTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports